export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = 'e5787e74-33b2-44d7-b30e-9383ad730952';
export const MODAL_CLOSE_SEC = 2.5;
